import { render, staticRenderFns } from "./BreadcrumbParcel.vue?vue&type=template&id=0ee05c1a&"
import script from "./BreadcrumbParcel.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports